<template>
    <div class="app">
        <Loading :value="loading"></Loading>

          <v-dialog v-model="dialogAjoutCarteRgt" max-width="60%" persistent :overlay="true" scrollable>
      <v-card >
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
              <span v-if="editRgt == false" > Ajouter une carte carburant </span>
              <span v-else >Modifier une carte carburant  </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

          <v-card-text>
            <el-form id="formRgt"  :model="formRgt" :rules="rules" ref="formRgt" class="demo-form-inline">
               <v-layout row>
                    <v-flex xs6>
                        <div style="margin-top: 20px">
                            <el-radio-group v-model="typeRgt"   size="mini">
                                <el-radio-button label="Autre"></el-radio-button>
                                <el-radio-button label="Mission"></el-radio-button>
                                <el-radio-button label="Chantier"></el-radio-button>
                            </el-radio-group>
                        </div>
                    </v-flex>
                </v-layout>

                 <v-layout row>
                      
                      <v-flex xs4 class="ml-1" >
                           <el-form-item label="date de règlement"  prop="dateRgt">
                                 <el-date-picker v-model="formRgt.dateRgt" format="d-MM-yyyy HH:mm" value-format="yyyy-MM-d HH:mm" name="dateRgt" type="datetime" placeholder="Date de reglement" style="width:100%" ></el-date-picker>
                            </el-form-item>
                      </v-flex>
                   
                
                      <v-flex xs4  class="ml-1" >  
                            <el-form-item label="Montant" prop="montant">
                                <el-input-number  :min="0"  v-model="formRgt.montant" name="montant" placeholder="saisir un montant"  style="width: 100%"></el-input-number>
                            </el-form-item>
                      </v-flex>

                       <v-flex  xs4  class="ml-1" v-if="typeRgt == 'Chantier'">
                        <el-form-item   label="Chantier concerné" style="width:100%">
                            <el-select filterable clearable v-model="formRgt.chantierId"  placeholder="Selectionner un chantier" style="width:100%">
                                <el-option v-for="item in comboChantier" :key="item.id" :label="item.text" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </v-flex>

                     <v-flex  xs4  class="ml-1" v-if="typeRgt == 'Mission'">
                        <el-form-item  label="Mission concerné" style="width:100%">
                            <el-select @change="handleMision" filterable clearable v-model="formRgt.missionId"  placeholder="Selectionner une mission" style="width:100%" :value="formRgt.missionId" >
                                <el-option v-for="item in comboMission" :key="item.id" :label="item.text" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </v-flex>


                </v-layout>

                <v-layout row >

                  
                   

                     <v-flex xs5 class="ml-1" >
                        <el-form-item label="Description" prop="description">
                            <el-input type="textarea" :row="25"   v-model="formRgt.description" name="description" placeholder="description"  style="width: 100%"></el-input>
                        </el-form-item>
                        </v-flex>
                </v-layout>
                <v-layout row class="text-xs-right">
                    <v-flex  xs12 >
                        <el-form-item  class="text-xs-right" >
                            <v-btn color="grey"  @click="resetForm('formCarte')" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                            <v-btn v-if="editRgt == null" icons dark color="green" @click="submitForm('formRgt')">Enregistrer<v-icon right>add</v-icon></v-btn>
                            <v-btn v-else  icons dark color="green" @click="submitForm('formRgt')">Modifier<v-icon right>edit</v-icon></v-btn>
                        </el-form-item>
                    </v-flex>
                </v-layout>
            </el-form>
    
        </v-card-text>

      </v-card>
    </v-dialog>
    
    </div>
</template>
<script>

    
    import Loading from '@/components/Loading'
    export default {
        components:{ Loading },
        name: "AjoutReglementCArte",
        props: {
            show:{
                type: Boolean,
                //required: true
            },
            editRgt: {
                type: Object,
                default:{}
                
            },
             carte: {
                type: Object,
                required: true
               
            },
        
        },
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,
                // racourcis: [
                //     { path: '/', text: 'Accueil', disabled: false },
                //     { path: '/demandeFond', text: 'Demande de fonds', disabled: true }
                // ],
                dialogAjoutCarteRgt: false,
                 rules: {
                    dateRgt: [
                         { required: true, message: 'Choisir une date ',trigger: 'change'  }
                    ],
                     montant: [
                        { required: true, message: 'Veuillez saisir un montant' },
                    ],
                    
                 },
                comboChantier:[],
                comboMission:[],
                formRgt:{
                    dateRgt:''
                },
                typeRgt: 'Autre',
               
            }
        },

        watch:{
            show: function(newValue,oldValue){
                this.dialogAjoutCarteRgt = newValue;
                this.resetForm('formRgt');
                 this.typeRgt = "Autre";
                if(newValue == true){
                    this.loadChantier();
                    this.loadMission();
                }

                if(this.editRgt.id != null)
                {
                    this.formRgt.dateRgt = this.editRgt.dateRgtNoFormat;
                    //this.formRgt.dateRgt = "";
                    this.formRgt.montant = this.editRgt.montant;
                    if(this.editRgt.chantierId) {
                        this.formRgt.chantierId = this.editRgt.chantierId;
                        this.typeRgt = "Chantier";
                    }else if (this.editRgt.missionId )
                    {
                         this.formRgt.missionId = this.editRgt.missionId;
                         this.typeRgt = "Mission";
                    }
                    else {
                        this.typeRgt = "Autre";
                    }
                    
                   
                    this.formRgt.description = this.editRgt.description;
                }
            }
        },

        methods: {
            loadChantier() {
                let url = this.domaine + "chantier/index";
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.comboChantier = response.body.chantier;
                    }
                });
            },

             loadMission() {
                let url = this.domaine + "mission/combo_mission";
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.comboMission = response.body.missions;
                    }
                });
            },

            // createFilter(queryString) {
            //     return (link) => {
            //         return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            //     }
            // },
            closeDialog(){
                this.$emit("close");
            },

            handleMision(idMission){
                this.formRgt.missionId = ''
                console.log("mission")
                console.log(idMission)
                 this.formRgt.missionId = idMission;
            },

            submitForm(formName) 
            {
                this.$refs[formName].validate((valid) => {
                if (valid) 
                {
                 this.loading = true
                 let form = document.getElementById("formRgt")
                 //recuperation des demandes
                 let data = new FormData(form);
                 let url = "";
                 if( this.editRgt.id == null) //creer une nouvelle demande
                 {
                   url = this.domaine + 'carteCarburant/reglement/create'
                 }
                
                 else  //modifier une demande de maintenance
                  {
                    url = this.domaine + 'carteCarburant/reglement/edit'
                     data.append("idRgt", this.editRgt.id)
                 }
              
            
                    console.log("carte")
                     console.log(this.carte)
                 data.append("userId",this.user.id)
                 data.append("carteId",this.carte.carteId)
                 data.append("dateRgt",this.formRgt.dateRgt)
                 if(this.typeRgt == "Mission"){
                     data.append("missionId", this.formRgt.missionId)
                 }
                 else if(this.typeRgt == "Chantier")
                 {
                     data.append("chantierId", this.formRgt.chantierId)
                 }
                 
                 
                 this.$http.post(url, data).then(response => {
                     //reinitialiser le formulaire
                     this.loading = false
                     this.resetForm('formRgt')
                     this.formRgt.description = ''
                     this.successNotif(response.body.message)
                     this.closeDialog()
                },
                (erreur) => {
                    //reinitialiser le formulaire
                    this.loading = false
                    this.resetForm('formRgt')
                    this.formRgt.description = ''
                    this.closeDialog()
                    this.$message.error("Une erreur est survenue lors de l'enregistrement du règlement")
                })
            } 
            });
            },

             resetForm(formName) {
                console.log("resetForm")
                this.$refs[formName].resetFields();
            },

            successNotif(mess = "")
            {
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center',
                        duration: 10000
                })
            },
        },

        mounted() 
        {
         
        }
    };
</script>

<style scoped>
    .toolbar_content {
        height:37px; 
    }
</style>



// WEBPACK FOOTER //
// src/components/carteCarburant/AjoutReglementCarte.vue